/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useMemo, useState } from 'react'
import { ENDPOINTS } from 'apps/placeme/src/constants/endpoints'
import { useSelector } from 'react-redux'
import { RootState } from 'apps/placeme/src/redux/store'
import styled from 'styled-components'
import { IChainBenchmarkData } from './@types/IChainBenchmark'
import ChainBenchmarkTile from './ChainBenchmarkTile'

const ContentWrapper = styled.div`
  padding: 1.25rem;
`

export interface SelectedLabelProps {
  id: string
  value: string
}

interface ChainBenchmarkModelProps {
  data: IChainBenchmarkData,
  tileId: string
  categoryId: string
}

function ChainBenchmarkModel({
  data, tileId, categoryId,
}: ChainBenchmarkModelProps) {
  const [selectedLabel, setSelectedLabel] = useState<SelectedLabelProps | null>(null)
  const {
    analyseId,
    value: {
      lat, lng,
    } = {},
  } = useSelector((state: RootState) => state.location)

  const body = useMemo(() => ({
    coordinates: {
      lat: lat!,
      lng: lng!,
    },
    reportId: analyseId!,
    labelId: selectedLabel?.id,
  }), [lat, lng, analyseId, selectedLabel])

  return (
    <ContentWrapper>
      <ChainBenchmarkTile
        body={body}
        categoryId={categoryId}
        data={data}
        endpoint={ENDPOINTS.CHAIN_BENCHMARK_TILE}
        selectedLabel={selectedLabel}
        setSelectedLabel={setSelectedLabel}
        tileId={tileId}
      />
    </ContentWrapper>
  )
}

export default ChainBenchmarkModel
